export const getGoalAndDisplayDetails = {
  'goal': 'goal',
  '4-Pager/Mega': '4-Pager/Mega',
  'Display': 'display'
}

export const getLocalOfferNames = {
  'offerName': 'offerName',
  'offerId': 'offerId'
}

export const getLocalRejectOfferResult = {
  'offerName': 'offerName',
  'offerId': 'offerId'
}

export const SubmittedOfferTableKeys = {
  'period': '0',
  'category': '1',
  'description': '2',
  'UPC': '3',
  'brand-name': '4',
  'size': '3',
  'UOM': '4',
  'CPTS': '5',
  'off_invoice_allowance_amount': '6',
  'scan_back_allowance_amount': '7',
  'total': '8',
  'URR': '9',
  'suggested_retail_savings': '10',
  'offer_name': '11',
  'offer_period': '12'
}



// WEBPACK FOOTER //
// ./src/components/shared/helper/ViewKeyToServerKeyMapper.js